if (!customElements.get('rg10000-signup')) {
  customElements.define('rg10000-signup', class extends HTMLElement {
    connectedCallback() {
      this.loading = this.querySelector('.rg10000-signup__loading');
      this.unavailable = this.querySelector('.rg10000-signup__unavailable');
      this.mount = this.querySelector('[data-rg-klaviyo]');
      if (!this.mount || !this.loading || !this.unavailable) return;
      this.refresh = () => window.location.reload();
      this.querySelector('[data-rg-retry]')?.addEventListener('click', this.refresh);
      this.check = () => {
        if (!this.mount.querySelector('form')) return;
        this.dataset.state = 'ready';
        this.loading.hidden = true;
        this.unavailable.hidden = true;
        clearTimeout(this.timeout);
      };
      this.observer = new MutationObserver(this.check);
      this.observer.observe(this.mount, { childList: true, subtree: true });
      this.timeout = setTimeout(() => {
        if (this.dataset.state === 'ready') return;
        this.dataset.state = 'unavailable';
        this.loading.hidden = true;
        this.unavailable.hidden = false;
      }, 15000);
      this.check();
    }
    disconnectedCallback() {
      clearTimeout(this.timeout);
      this.observer?.disconnect();
      this.querySelector('[data-rg-retry]')?.removeEventListener('click', this.refresh);
    }
  });
}
